// extracted by mini-css-extract-plugin
export default {"container":"image_container__1pfqB","maintainRatio":"image_maintainRatio__17ZEn"};